function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#222",
  d: "M159.8 80c-.7 0-1.5.1-2.2.2H16c-8.8 0-16 7.2-16 16v328c0 8.8 7.2 16 16 16h248c8.8 0 16-7.2 16-16V202.9c1-5.8-1.4-11.7-6-15.3L172.6 86.2c-3.1-4-7.8-6.2-12.8-6.2M32 112.3h112v85.4c-.8 5.1.9 10.4 4.6 14l.1.1c.1.1.2.1.2.2 3.6 3.5 8.7 5 13.7 4.2H248v192H32V112.3zm144 22.6l49.4 49.4H176v-49.4z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#BFBFBF",
  d: "M239.8 0c-.7 0-1.5.1-2.2.2H96c-4.2 0-8.4 1.7-11.3 4.7-3 3-4.7 7.1-4.7 11.3v44h32v-28h112v65.3l38.7 38.7H328v192h-28v32h44c4.2 0 8.4-1.7 11.3-4.7 3-3 4.7-7.1 4.7-11.3V122.8c.9-5.7-1.5-11.8-6-15.3L252.6 6.2c-3-3.9-7.9-6.3-12.8-6.2M256 54.9l49.4 49.4H256V54.9z"
});

var SvgCopy = function SvgCopy(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 360.2,
    height: 440.3,
    viewBox: "0 0 360.2 440.3",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCopy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy.9a31852a.svg";
export { ForwardRef as ReactComponent };